import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Toddy from '@/components/Toddy'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/toddy',
      name: 'Toddy',
      component: Toddy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js